import { bool, string } from 'prop-types';
import React, { PureComponent } from 'react';
import { View } from 'react-native';

import { LAYOUT, THEME } from '../../../../../reactor/common';
import { Motion, Image, Text } from '../../../../../reactor/components';
import styles from './Slide.style';

const { COLOR } = THEME;

class Slide extends PureComponent {
  static propTypes = {
    image: string,
    text: string,
    visible: bool,
  };

  static defaultProps = {
    image: undefined,
    text: undefined,
    visible: false,
  };

  render() {
    const {
      props: {
        image, text, visible, ...inherit
      },
    } = this;
    const { H, PORTRAIT, W } = LAYOUT.VIEWPORT;
    const size = { width: W, height: H };

    return (
      <Motion
        timeline={[{ property: 'translateX', value: visible ? 0 : -W }]}
        style={inherit.style}
      >
        <View style={[styles.container, size]}>
          { image
            && (
            <Image
              key={image}
              ratio={PORTRAIT ? 2 : 1}
              resizeMode="cover"
              responsive
              source={{ uri: image }}
              style={[styles.image, size]}
            />
            ) }
          { text
            && (
            <Motion
              timeline={[
                { property: 'opacity', value: visible ? 1 : 0 },
                { property: 'translateX', value: visible ? 0 : W / 2 },
              ]}
              style={{ maxWidth: PORTRAIT ? '85%' : '50%' }}
            >
              <Text headline level={PORTRAIT ? 4 : 2} color={COLOR.WHITE}>
                {text}
              </Text>
            </Motion>
            ) }
        </View>
      </Motion>
    );
  }
}

export default Slide;
